/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { countryCodes } from '@/constants/locale';
import { type Country } from '@/types';
import type { ISO3166Country, Locale } from '@/types/i18n';

export const getCountryFromLocale = (locale: Locale): Country => {
  switch (locale) {
    case countryCodes.us:
      return 'USA';
    case countryCodes.mx:
      return 'MEX';
    case countryCodes.ptBr:
      return 'BRA';
    default:
      return 'USA';
  }
};

export const getCountryFromISO3166 = (locale: Locale): ISO3166Country => {
  switch (locale) {
    case countryCodes.us:
      return 'US';
    case countryCodes.mx:
      return 'MX';
    case countryCodes.ptBr:
      return 'BR';
    default:
      return 'US';
  }
};
